(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5744"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5744"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cljH0", function(module, exports) {

$parcel$export(module.exports, "createSVGGrid", () => $8fc6b8bbd146cdca$export$d47c320381fa2abf);
function $8fc6b8bbd146cdca$export$d47c320381fa2abf(container, squaresPerRow, fill, onlyEmbed) {
    if (!container) {
        console.error("Container not found");
        return;
    }
    // Get the container's dimensions
    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;
    const responsiveSquares = window.innerWidth <= 991 ? squaresPerRow / 2 : squaresPerRow;
    // Calculate the size of each square
    const squareSize = parseInt(containerWidth / responsiveSquares);
    // Calculate the number of squares per column
    const squaresPerColumn = Math.ceil(containerHeight / squareSize);
    // Create a unique ID for the mask
    const maskId = "mask-" + Math.random().toString(36).substr(2, 9);
    if (!onlyEmbed) {
        // Create SVG content
        let svgContent = `
                <svg viewBox="0 0 ${containerWidth} ${containerHeight}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style="position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;">
                    <defs>
                        <mask id="${maskId}">
                            ${Array.from({
            length: squaresPerColumn
        }).map((_, row)=>Array.from({
                length: responsiveSquares
            }).map((_, col)=>{
                const x = col * squareSize;
                const y = row * squareSize;
                return `<rect x="${x}" y="${y}" width="${squareSize + 1}" height="${squareSize + 1}" fill="${fill ? fill : "#000000"}"/>`;
            }).join("")).join("")}
                        </mask>
                    </defs>
                </svg>`;
        // Create wrapper for the SVG and mask
        const maskContainer = document.createElement("div");
        maskContainer.className = "mask-container";
        maskContainer.style.maskImage = `url(#${maskId})`;
        // Append SVG to maskContainer
        maskContainer.innerHTML = svgContent;
        container.parentNode.insertBefore(maskContainer, container);
        maskContainer.appendChild(container);
        return maskContainer.querySelector("svg");
    } else {
        // Create SVG content
        let svgContent = `
                <svg viewBox="0 0 ${containerWidth} ${containerHeight}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style="position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;">
                            ${Array.from({
            length: squaresPerColumn
        }).map((_, row)=>Array.from({
                length: squaresPerRow
            }).map((_, col)=>{
                const x = col * squareSize;
                const y = row * squareSize;
                return `<rect x="${x}" y="${y}" width="${squareSize + 1}" height="${squareSize + 1}" fill="${fill ? fill : "#000000"}"/>`;
            }).join("")).join("")}
                </svg>`;
        container.insertAdjacentHTML("beforeend", svgContent);
        return svgContent;
    }
}

});

parcelRegister("kpGgi", function(module, exports) {

$parcel$export(module.exports, "getElementHeightInRem", () => $edc6ecc670d98733$export$d6278f2ff6cc02ee);
/**
 * Converts a length value from any CSS unit to pixels.
 * @param {string} value - The length value as a string (e.g., "2rem", "50px").
 * @returns {number} - The length value in pixels.
 */ function $edc6ecc670d98733$var$convertToPixels(value) {
    // Create a temporary element to use the browser's rendering to convert the value to pixels
    const tempElement = document.createElement("div");
    tempElement.style.position = "absolute";
    tempElement.style.visibility = "hidden";
    tempElement.style.width = value;
    document.body.appendChild(tempElement);
    const pixelValue = parseFloat(window.getComputedStyle(tempElement).width);
    document.body.removeChild(tempElement);
    return pixelValue;
}
function $edc6ecc670d98733$export$d6278f2ff6cc02ee(element) {
    if (!element) throw new Error("Element is required");
    // Get the computed style of the element
    const computedStyle = window.getComputedStyle(element);
    // Get the height of the element in pixels
    const heightInPixels = parseFloat(computedStyle.height);
    // Get the font size of the root element (html) in rem units and convert it to pixels
    const rootFontSizeInRem = window.getComputedStyle(document.documentElement).fontSize;
    const rootFontSizeInPixels = $edc6ecc670d98733$var$convertToPixels(rootFontSizeInRem);
    // Calculate height in rem units
    const heightInRem = heightInPixels / rootFontSizeInPixels;
    return heightInRem;
}

});


var $cljH0 = parcelRequire("cljH0");

var $kpGgi = parcelRequire("kpGgi");
let $ee4f70e205629d51$var$slides = [];
function $ee4f70e205629d51$var$initTestimonials() {
    // Variables
    const wrapper = document.querySelector(".testimonials-wrapper"), sliderContent = wrapper.querySelectorAll(".testimonial-item .testimonial-content"), names = wrapper.querySelector(".testimonial-source-wrapper .testimonial-source-list"), companies = wrapper.querySelector(".testimonial-company-wrapper .testimonial-source-list"), nextButton = document.querySelector(".button.next"), prevButton = document.querySelector(".button.prev");
    const namesHeight = Number((0, $kpGgi.getElementHeightInRem)(names.parentNode).toFixed(2));
    const companiesHeight = Number((0, $kpGgi.getElementHeightInRem)(companies.parentNode).toFixed(2));
    // console.log(namesHeight, companiesHeight);
    let currentIndex = 0;
    sliderContent.forEach((content)=>{
        const maskedEl = (0, $cljH0.createSVGGrid)(content, 10);
        const squares = maskedEl.querySelectorAll("rect"), parent = maskedEl.parentNode, maskImageId = parent.style.maskImage;
        const slideTl = gsap.timeline({
            paused: true
        });
        // next slide
        slideTl.fromTo(squares, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.005,
            overwrite: true,
            stagger: {
                each: 0.005,
                // grid: "auto",
                // from: "center"
                from: "random"
            },
            onComplete: ()=>{
                gsap.set(parent, {
                    maskImage: "none"
                });
            }
        });
        $ee4f70e205629d51$var$slides.push({
            tl: slideTl,
            parent: parent,
            id: maskImageId
        });
    });
    // gsap.set(".testimonial-item svg rect", {
    //   opacity: 0
    // });
    // gsap.set(".testimonial-item:first-child svg rect", {
    //   opacity: 1
    // });
    $ee4f70e205629d51$var$slides[0].tl.progress(1);
    // clone last and first item from each name and company
    const allNames = names.querySelectorAll(".testimonial-source"), firstName = allNames[0], firstNameClone = firstName.cloneNode(true), lastName = allNames[allNames.length - 1], lastNameClone = lastName.cloneNode(true);
    names.insertBefore(lastNameClone, firstName);
    names.append(firstNameClone);
    // set styles
    gsap.set(firstNameClone, {
        position: "absolute",
        top: "100%",
        left: 0
    });
    gsap.set(lastNameClone, {
        position: "absolute",
        bottom: "100%",
        left: 0
    });
    const allCompanies = companies.querySelectorAll(".testimonial-source"), firstCompany = allCompanies[0], firstCompanyClone = firstCompany.cloneNode(true), lastCompany = allCompanies[allCompanies.length - 1], lastCompanyClone = lastCompany.cloneNode(true);
    companies.insertBefore(lastCompanyClone, firstCompany);
    companies.append(firstCompanyClone);
    // set styles
    gsap.set(firstCompanyClone, {
        position: "absolute",
        top: "100%",
        left: 0
    });
    gsap.set(lastCompanyClone, {
        position: "absolute",
        bottom: "100%",
        left: 0
    });
    // Next button click
    nextButton.addEventListener("click", ()=>{
        let currentSlide = $ee4f70e205629d51$var$slides[currentIndex];
        if (currentIndex < $ee4f70e205629d51$var$slides.length - 1) {
            let nextSlide = $ee4f70e205629d51$var$slides[currentIndex + 1];
            $ee4f70e205629d51$var$transitionSlides(currentSlide, nextSlide, currentIndex + 1, $ee4f70e205629d51$var$slides.length - 1, "next", names, namesHeight, companies, companiesHeight);
            currentIndex++;
        } else {
            let nextSlide = $ee4f70e205629d51$var$slides[0];
            $ee4f70e205629d51$var$transitionSlides(currentSlide, nextSlide, 0, $ee4f70e205629d51$var$slides.length - 1, "next", names, namesHeight, companies, companiesHeight);
            currentIndex = 0;
        }
    });
    // Prev button click
    prevButton.addEventListener("click", ()=>{
        let currentSlide = $ee4f70e205629d51$var$slides[currentIndex];
        if (currentIndex > 0) {
            let prevSlide = $ee4f70e205629d51$var$slides[currentIndex - 1];
            $ee4f70e205629d51$var$transitionSlides(currentSlide, prevSlide, currentIndex - 1, $ee4f70e205629d51$var$slides.length - 1, "prev", names, namesHeight, companies, companiesHeight);
            currentIndex--;
        } else {
            let prevSlide = $ee4f70e205629d51$var$slides[$ee4f70e205629d51$var$slides.length - 1];
            $ee4f70e205629d51$var$transitionSlides(currentSlide, prevSlide, $ee4f70e205629d51$var$slides.length - 1, $ee4f70e205629d51$var$slides.length - 1, "prev", names, namesHeight, companies, companiesHeight);
            currentIndex = sliderContent.length - 1;
        }
    });
}
function $ee4f70e205629d51$var$transitionSlides(current, next, index, total, direction, names, namesHeight, companies, companiesHeight) {
    // console.log(current, next);
    current.tl.eventCallback("onReverseComplete", ()=>{
        next.tl.play();
    });
    gsap.set(current.parent, {
        maskImage: current.id
    });
    current.tl.reverse();
    // names list
    const yNames = $ee4f70e205629d51$var$calculateYPosition(index, total, direction, namesHeight);
    // console.log(index, total, direction, yNames);
    gsap.to(names, {
        y: `${yNames}rem`,
        duration: 0.5,
        ease: "expo.out"
    });
    // companies list
    const yCompanies = $ee4f70e205629d51$var$calculateYPosition(index, total, direction, companiesHeight);
    gsap.to(companies, {
        y: `${yCompanies}rem`,
        duration: 0.5,
        ease: "expo.out"
    });
}
function $ee4f70e205629d51$var$calculateYPosition(index, total, direction, height) {
    if (index === 0 && direction === "prev") return 0;
    if (index === total && direction === "next") return -1 * height * total;
    const newIndex = direction === "next" ? index + 1 : index - 1;
    return index * (-1 * height);
}
document.fonts.ready.then(()=>{
    $ee4f70e205629d51$var$initTestimonials();
});

})();
//# sourceMappingURL=testimonials.js.map
